import JobWorkerRejectedReason from "@/models/JobWorkers/JobWorkerRejectedReason";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJobWorkerStatusContactInterestedRequest extends BaseUpdateRequest  { 
    jobWorkerId = '';
    rejectedReason: JobWorkerRejectedReason = 0;
}
